import { useState, useEffect } from "react";

function useDebouncer(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Only update debounced value if the incoming value changes
    if (debouncedValue !== value) {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [value, delay, debouncedValue]);

  return debouncedValue;
}

export function useDebouncerObject(object, delay) {
  const [debouncedValue, setDebouncedValue] = useState(object);

  useEffect(() => {
    if (debouncedValue.value !== object.value) {
      const handler = setTimeout(() => {
        setDebouncedValue(object);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [object, delay, debouncedValue]);

  return debouncedValue;
}

export default useDebouncer;
